import Route from '@ember/routing/route';
import CampaignGoalModel from 'donor-elf-web/models/campaign-goal';
import { type CampaignsCampaignRouteModel } from '../../campaign';
import { service } from '@ember/service';
import CampaignService from 'donor-elf-web/services/campaign-service';

export interface CampaignGoalRouteModel extends CampaignsCampaignRouteModel {
  campaignGoal: CampaignGoalModel;
}

export default class CampaignGoalRoute extends Route {
  @service declare CampaignService: CampaignService;

  async model(params: {
    campaignGoalId: string;
  }): Promise<CampaignGoalRouteModel> {
    let campaignModel = this.modelFor(
      'funds.fund.campaigns.campaign',
    ) as CampaignsCampaignRouteModel;
    let campaignGoal: CampaignGoalModel;
    let activeCampaignGoal =
      this.CampaignService.activeCampaignGoalsByCampaignId[
        campaignModel.campaign.id
      ];
    if (params.campaignGoalId === 'active') {
      campaignGoal = activeCampaignGoal;
    } else {
      if (params.campaignGoalId === activeCampaignGoal.id) {
        campaignGoal = activeCampaignGoal;
      } else {
        campaignGoal = (
          await this.store.query('campaign-goal', {
            filter: {
              campaign_id: campaignModel.campaign.id,
              campaign_goal_id: params.campaignGoalId,
            },
          })
        ).slice()[0];
      }
    }
    return { ...campaignModel, campaignGoal };
  }
}
